import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
  { code: "pt", label: "PT", name: "Português" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "ar", label: "AR", name: "العربية", rtl: true },
  { code: "tr", label: "TR", name: "Türkçe" },
];

export const translations = {
  en: {
    title: "Rec-League Radar",
    subtitle: "The Ultimate Amateur Transfer Hub",
    liveMarket: "Live Market",
    breaking: "Breaking",
    ticker: [
      "TRANSFER WINDOW OPEN",
      "FULL-SEASON DEALS AVAILABLE",
      "MEDICALS BOOKED DAILY",
      "CAPTAINS ON RED ALERT",
      "EXCLUSIVE: TOP TALENT STILL UNSIGNED",
    ],
    totalFreeAgents: "Total Free Agents",
    resetMarket: "Reset Market",
    selectMarket: "Select Market",
    allCities: "All Cities",
    registerFreeAgent: "Register as Free Agent",
    transferMarket: "Transfer Market",
    clubhouse: "The Clubhouse",
    clubhouseDesc: "Tournaments, socials & pickup games in your market.",
    communityBoard: "Community Bulletin Board",
    postEvent: "Post an Event",
    postEventTitle: "Post to the Clubhouse",
    postEventDesc: "Share a tournament, social or pickup game with your city.",
    eventTextLabel: "Event details",
    eventPlaceholder: "e.g., ⚽ Casual Pickup at Penn Park 6PM",
    submitPost: "Post",
    posting: "Posting…",
    toastPosted: "Event posted to the Clubhouse!",
    toastPostError: "Could not post the event. Try again.",
    postFormError: "Please enter event details.",
    noPosts: "No events in this market yet. Be the first to post!",
    watchTape: "Watch Tape",
    uploadVideo: "Upload from Camera Roll / Device",
    uploading: "Uploading…",
    removeFile: "Remove",
    whatsHappening: "What's happening on the pitch?",
    attachMedia: "Attach Image/Video",
    mediaAttached: "Media attached",
    writeComment: "Write a comment…",
    send: "Send",
    you: "You",
    roleCaptain: "Captain",
    rolePlayer: "Player",
    roleAdmin: "League Admin",
    highlightClip: "Highlight clip",
    leagueType: "League Preference",
    allLeagueTypes: "All League Preferences",
    selectLeague: "Select league type",
    scoutingOrigin: "Scouting Origin",
    originNone: "None yet",
    goodRecBadge: "🔥 GoodRec Pickup Regular",
    casaBadge: "🏆 CASA League Veteran",
    videoLabel: "Highlight Video Link",
    videoPlaceholder: "e.g., https://youtube.com/watch?v=...",
    optionalTag: "(optional)",
    registerTitle: "Join the Talent Pool",
    registerDesc: "Get scouted by captains across the country.",
    nameLabel: "Name",
    cityLabel: "City",
    namePlaceholder: "e.g., Sunday League Legend",
    stylePlaceholder: "e.g., Tiki-Taka Midfielder",
    commitmentPlaceholder: "e.g., 100% Weekend",
    selectCity: "Select a city",
    selectPosition: "Select a position",
    submitRegister: "Register",
    cancel: "Cancel",
    registering: "Registering…",
    toastRegistered: "{name} joined the talent pool!",
    toastRegisterError: "Registration failed. Try again.",
    formError: "Please fill in all fields (stats must be 1-99).",
    scoutingDesk: "Scouting Desk",
    clearFilters: "Clear filters",
    searchLabel: "Ask the Chief Scout",
    searchPlaceholder: "e.g., I need a fast defender...",
    allPositions: "All Positions",
    allStyles: "All Styles",
    allCommitments: "All Commitments",
    position: "Position",
    style: "Style",
    commitment: "Commitment",
    breakingAvailable: "Breaking — Available Now",
    freeAgents: "Free Agents",
    dealsDone: "Deals Done",
    signedOffMarket: "Completed Transfers",
    transferComplete: "TRANSFER COMPLETE",
    freeAgentTag: "Free Agent",
    signedBadge: "SIGNED",
    signFullSeason: "Sign Full Season",
    finalizingDeal: "Finalizing deal…",
    pace: "Pace",
    defense: "Defense",
    passing: "Passing",
    hereWeGo: "Here We Go!",
    officialConfirmed: "Official & Confirmed",
    exclusiveText:
      "🚨 HERE WE GO! EXCLUSIVE: {name} signs full-season deal in {city}! The {style} {position} is off the market. ✍️🤝",
    close: "Close",
    copyToChat: "Copy to Clipboard",
    copied: "Copied!",
    marketSwept: "Market swept clean",
    noMatch: "No free agents match your scouting criteria.",
    allSigned: "Every player has been signed. Reset the market to reopen the window.",
    resetFiltersBtn: "Reset filters",
    signalLost: "Signal lost",
    connectionError: "Could not reach the transfer desk. Check your connection and retry.",
    retry: "Retry",
    toastReset: "Market reset — every player is a Free Agent again.",
    toastResetError: "Could not reset the market. Try again.",
    toastSignError: "Deal collapsed at the last minute. Try again.",
    toastCopied: "Breaking news copied — paste it in the team chat!",
    footer: "Rec-League Radar — Trusted by captains. Zero fake ITKs.",
  },
  es: {
    title: "Radar Liga Amateur",
    subtitle: "El Centro Definitivo de Fichajes Amateur",
    liveMarket: "Mercado en Vivo",
    breaking: "Última Hora",
    ticker: [
      "MERCADO DE FICHAJES ABIERTO",
      "CONTRATOS DE TEMPORADA COMPLETA DISPONIBLES",
      "RECONOCIMIENTOS MÉDICOS A DIARIO",
      "CAPITANES EN ALERTA ROJA",
      "EXCLUSIVA: GRANDES TALENTOS SIN FIRMAR",
    ],
    totalFreeAgents: "Agentes Libres Totales",
    resetMarket: "Reiniciar Mercado",
    selectMarket: "Seleccionar Mercado",
    allCities: "Todas las Ciudades",
    registerFreeAgent: "Regístrate como Agente Libre",
    transferMarket: "Mercado de Fichajes",
    clubhouse: "El Club Social",
    clubhouseDesc: "Torneos, eventos sociales y partidos casuales en tu mercado.",
    communityBoard: "Tablón de la Comunidad",
    postEvent: "Publicar un Evento",
    postEventTitle: "Publicar en el Club Social",
    postEventDesc: "Comparte un torneo, evento social o partido casual con tu ciudad.",
    eventTextLabel: "Detalles del evento",
    eventPlaceholder: "ej: ⚽ Partido casual en Penn Park 6PM",
    submitPost: "Publicar",
    posting: "Publicando…",
    toastPosted: "¡Evento publicado en el Club Social!",
    toastPostError: "No se pudo publicar el evento. Inténtalo de nuevo.",
    postFormError: "Por favor escribe los detalles del evento.",
    noPosts: "Aún no hay eventos en este mercado. ¡Sé el primero en publicar!",
    watchTape: "Ver Video",
    uploadVideo: "Subir desde el Carrete / Dispositivo",
    uploading: "Subiendo…",
    removeFile: "Quitar",
    whatsHappening: "¿Qué está pasando en la cancha?",
    attachMedia: "Adjuntar Imagen/Video",
    mediaAttached: "Multimedia adjunta",
    writeComment: "Escribe un comentario…",
    send: "Enviar",
    you: "Tú",
    roleCaptain: "Capitán",
    rolePlayer: "Jugador",
    roleAdmin: "Admin de la Liga",
    highlightClip: "Clip destacado",
    leagueType: "Preferencia de Liga",
    allLeagueTypes: "Todas las Preferencias de Liga",
    selectLeague: "Selecciona tipo de liga",
    scoutingOrigin: "Origen de Scouting",
    originNone: "Ninguno aún",
    goodRecBadge: "🔥 Habitual del Pickup GoodRec",
    casaBadge: "🏆 Veterano de Liga CASA",
    videoLabel: "Enlace de Video de Highlights",
    videoPlaceholder: "ej: https://youtube.com/watch?v=...",
    optionalTag: "(opcional)",
    registerTitle: "Únete a la Cantera",
    registerDesc: "Deja que los capitanes de todo el país te descubran.",
    nameLabel: "Nombre",
    cityLabel: "Ciudad",
    namePlaceholder: "ej: Leyenda de la Liga Dominical",
    stylePlaceholder: "ej: Mediocampista Tiki-Taka",
    commitmentPlaceholder: "ej: 100% Fin de Semana",
    selectCity: "Selecciona una ciudad",
    selectPosition: "Selecciona una posición",
    submitRegister: "Registrarse",
    cancel: "Cancelar",
    registering: "Registrando…",
    toastRegistered: "¡{name} se unió a la cantera!",
    toastRegisterError: "El registro falló. Inténtalo de nuevo.",
    formError: "Completa todos los campos (estadísticas de 1 a 99).",
    scoutingDesk: "Mesa de Ojeadores",
    clearFilters: "Limpiar filtros",
    searchLabel: "Pregunta al Jefe de Ojeadores",
    searchPlaceholder: "ej: Necesito un defensa rápido...",
    allPositions: "Todas las Posiciones",
    allStyles: "Todos los Estilos",
    allCommitments: "Todos los Compromisos",
    position: "Posición",
    style: "Estilo",
    commitment: "Compromiso",
    breakingAvailable: "Última Hora — Disponibles Ya",
    freeAgents: "Agentes Libres",
    dealsDone: "Fichajes Cerrados",
    signedOffMarket: "Traspasos Completados",
    transferComplete: "TRASPASO COMPLETO",
    freeAgentTag: "Agente Libre",
    signedBadge: "FICHADO",
    signFullSeason: "Fichar Temporada Completa",
    finalizingDeal: "Cerrando el fichaje…",
    pace: "Velocidad",
    defense: "Defensa",
    passing: "Pase",
    hereWeGo: "Here We Go!",
    officialConfirmed: "Oficial y Confirmado",
    exclusiveText:
      "🚨 HERE WE GO! EXCLUSIVA: ¡{name} firma por toda la temporada en {city}! El {style} {position} está fuera del mercado. ✍️🤝",
    close: "Cerrar",
    copyToChat: "Copiar al Portapapeles",
    copied: "¡Copiado!",
    marketSwept: "Mercado arrasado",
    noMatch: "Ningún agente libre coincide con tus criterios.",
    allSigned: "Todos los jugadores han sido fichados. Reinicia el mercado para reabrir la ventana.",
    resetFiltersBtn: "Reiniciar filtros",
    signalLost: "Señal perdida",
    connectionError: "No se pudo contactar la mesa de fichajes. Revisa tu conexión y reintenta.",
    retry: "Reintentar",
    toastReset: "Mercado reiniciado — todos los jugadores son agentes libres de nuevo.",
    toastResetError: "No se pudo reiniciar el mercado. Inténtalo de nuevo.",
    toastSignError: "El fichaje se cayó en el último momento. Inténtalo de nuevo.",
    toastCopied: "¡Noticia copiada — pégala en el chat del equipo!",
    footer: "Radar Liga Amateur — De confianza para capitanes. Cero ITKs falsos.",
  },
  pt: {
    title: "Radar da Liga Amadora",
    subtitle: "O Centro Definitivo de Transferências Amadoras",
    liveMarket: "Mercado ao Vivo",
    breaking: "Urgente",
    ticker: [
      "JANELA DE TRANSFERÊNCIAS ABERTA",
      "CONTRATOS DE TEMPORADA COMPLETA DISPONÍVEIS",
      "EXAMES MÉDICOS AGENDADOS DIARIAMENTE",
      "CAPITÃES EM ALERTA VERMELHO",
      "EXCLUSIVO: GRANDES TALENTOS AINDA SEM CONTRATO",
    ],
    totalFreeAgents: "Total de Agentes Livres",
    resetMarket: "Reiniciar Mercado",
    selectMarket: "Selecionar Mercado",
    allCities: "Todas as Cidades",
    registerFreeAgent: "Registre-se como Agente Livre",
    transferMarket: "Mercado de Transferências",
    clubhouse: "O Clube",
    clubhouseDesc: "Torneios, eventos sociais e peladas na sua cidade.",
    communityBoard: "Mural da Comunidade",
    postEvent: "Publicar um Evento",
    postEventTitle: "Publicar no Clube",
    postEventDesc: "Compartilhe um torneio, evento social ou pelada com sua cidade.",
    eventTextLabel: "Detalhes do evento",
    eventPlaceholder: "ex: ⚽ Pelada no Penn Park às 18h",
    submitPost: "Publicar",
    posting: "Publicando…",
    toastPosted: "Evento publicado no Clube!",
    toastPostError: "Não foi possível publicar o evento. Tente novamente.",
    postFormError: "Digite os detalhes do evento.",
    noPosts: "Ainda não há eventos neste mercado. Seja o primeiro a publicar!",
    watchTape: "Ver Vídeo",
    uploadVideo: "Enviar da Galeria / Dispositivo",
    uploading: "Enviando…",
    removeFile: "Remover",
    whatsHappening: "O que está acontecendo no campo?",
    attachMedia: "Anexar Imagem/Vídeo",
    mediaAttached: "Mídia anexada",
    writeComment: "Escreva um comentário…",
    send: "Enviar",
    you: "Você",
    roleCaptain: "Capitão",
    rolePlayer: "Jogador",
    roleAdmin: "Admin da Liga",
    highlightClip: "Clipe de destaque",
    leagueType: "Preferência de Liga",
    allLeagueTypes: "Todas as Preferências de Liga",
    selectLeague: "Selecione o tipo de liga",
    scoutingOrigin: "Origem do Scouting",
    originNone: "Nenhuma ainda",
    goodRecBadge: "🔥 Frequentador do Pickup GoodRec",
    casaBadge: "🏆 Veterano da Liga CASA",
    videoLabel: "Link do Vídeo de Melhores Momentos",
    videoPlaceholder: "ex: https://youtube.com/watch?v=...",
    optionalTag: "(opcional)",
    registerTitle: "Entre para o Banco de Talentos",
    registerDesc: "Seja descoberto por capitães de todo o país.",
    nameLabel: "Nome",
    cityLabel: "Cidade",
    namePlaceholder: "ex: Lenda da Liga de Domingo",
    stylePlaceholder: "ex: Meio-campista Tiki-Taka",
    commitmentPlaceholder: "ex: 100% Fim de Semana",
    selectCity: "Selecione uma cidade",
    selectPosition: "Selecione uma posição",
    submitRegister: "Registrar",
    cancel: "Cancelar",
    registering: "Registrando…",
    toastRegistered: "{name} entrou para o banco de talentos!",
    toastRegisterError: "O registro falhou. Tente novamente.",
    formError: "Preencha todos os campos (estatísticas de 1 a 99).",
    scoutingDesk: "Mesa de Olheiros",
    clearFilters: "Limpar filtros",
    searchLabel: "Pergunte ao Chefe dos Olheiros",
    searchPlaceholder: "ex: Preciso de um zagueiro rápido...",
    allPositions: "Todas as Posições",
    allStyles: "Todos os Estilos",
    allCommitments: "Todos os Compromissos",
    position: "Posição",
    style: "Estilo",
    commitment: "Compromisso",
    breakingAvailable: "Urgente — Disponíveis Agora",
    freeAgents: "Agentes Livres",
    dealsDone: "Negócios Fechados",
    signedOffMarket: "Transferências Concluídas",
    transferComplete: "TRANSFERÊNCIA CONCLUÍDA",
    freeAgentTag: "Agente Livre",
    signedBadge: "CONTRATADO",
    signFullSeason: "Contratar Temporada Completa",
    finalizingDeal: "Finalizando o negócio…",
    pace: "Velocidade",
    defense: "Defesa",
    passing: "Passe",
    hereWeGo: "Here We Go!",
    officialConfirmed: "Oficial e Confirmado",
    exclusiveText:
      "🚨 HERE WE GO! EXCLUSIVO: {name} assina para a temporada completa em {city}! O {style} {position} está fora do mercado. ✍️🤝",
    close: "Fechar",
    copyToChat: "Copiar para a Área de Transferência",
    copied: "Copiado!",
    marketSwept: "Mercado varrido",
    noMatch: "Nenhum agente livre corresponde aos seus critérios.",
    allSigned: "Todos os jogadores foram contratados. Reinicie o mercado para reabrir a janela.",
    resetFiltersBtn: "Redefinir filtros",
    signalLost: "Sinal perdido",
    connectionError: "Não foi possível contatar a mesa de transferências. Verifique sua conexão e tente novamente.",
    retry: "Tentar novamente",
    toastReset: "Mercado reiniciado — todos os jogadores são agentes livres novamente.",
    toastResetError: "Não foi possível reiniciar o mercado. Tente novamente.",
    toastSignError: "O negócio caiu no último minuto. Tente novamente.",
    toastCopied: "Notícia copiada — cole no chat do time!",
    footer: "Radar da Liga Amadora — Confiado pelos capitães. Zero ITKs falsos.",
  },
  fr: {
    title: "Radar Ligue Amateur",
    subtitle: "Le Hub Ultime des Transferts Amateurs",
    liveMarket: "Marché en Direct",
    breaking: "Alerte Info",
    ticker: [
      "MERCATO OUVERT",
      "CONTRATS SAISON COMPLÈTE DISPONIBLES",
      "VISITES MÉDICALES CHAQUE JOUR",
      "CAPITAINES EN ALERTE ROUGE",
      "EXCLUSIF : TOP TALENTS TOUJOURS LIBRES",
    ],
    totalFreeAgents: "Total Agents Libres",
    resetMarket: "Réinitialiser le Marché",
    selectMarket: "Choisir le Marché",
    allCities: "Toutes les Villes",
    registerFreeAgent: "S'inscrire comme Agent Libre",
    transferMarket: "Marché des Transferts",
    clubhouse: "Le Club House",
    clubhouseDesc: "Tournois, soirées et matchs improvisés dans votre marché.",
    communityBoard: "Tableau Communautaire",
    postEvent: "Publier un Événement",
    postEventTitle: "Publier au Club House",
    postEventDesc: "Partagez un tournoi, une soirée ou un match improvisé avec votre ville.",
    eventTextLabel: "Détails de l'événement",
    eventPlaceholder: "ex : ⚽ Match improvisé à Penn Park 18h",
    submitPost: "Publier",
    posting: "Publication…",
    toastPosted: "Événement publié au Club House !",
    toastPostError: "Impossible de publier l'événement. Réessayez.",
    postFormError: "Veuillez saisir les détails de l'événement.",
    noPosts: "Aucun événement dans ce marché pour l'instant. Soyez le premier à publier !",
    watchTape: "Voir la Vidéo",
    uploadVideo: "Importer depuis la Galerie / l'Appareil",
    uploading: "Envoi en cours…",
    removeFile: "Retirer",
    whatsHappening: "Que se passe-t-il sur le terrain ?",
    attachMedia: "Joindre Image/Vidéo",
    mediaAttached: "Média joint",
    writeComment: "Écrivez un commentaire…",
    send: "Envoyer",
    you: "Vous",
    roleCaptain: "Capitaine",
    rolePlayer: "Joueur",
    roleAdmin: "Admin de la Ligue",
    highlightClip: "Clip fort",
    leagueType: "Préférence de Ligue",
    allLeagueTypes: "Toutes les Préférences de Ligue",
    selectLeague: "Sélectionnez le type de ligue",
    scoutingOrigin: "Origine du Scouting",
    originNone: "Aucune pour l'instant",
    goodRecBadge: "🔥 Habitué du Pickup GoodRec",
    casaBadge: "🏆 Vétéran de la Ligue CASA",
    videoLabel: "Lien Vidéo Highlights",
    videoPlaceholder: "ex : https://youtube.com/watch?v=...",
    optionalTag: "(facultatif)",
    registerTitle: "Rejoignez le Vivier de Talents",
    registerDesc: "Faites-vous repérer par des capitaines de tout le pays.",
    nameLabel: "Nom",
    cityLabel: "Ville",
    namePlaceholder: "ex : Légende de la ligue du dimanche",
    stylePlaceholder: "ex : Milieu tiki-taka",
    commitmentPlaceholder: "ex : 100% Week-end",
    selectCity: "Sélectionnez une ville",
    selectPosition: "Sélectionnez un poste",
    submitRegister: "S'inscrire",
    cancel: "Annuler",
    registering: "Inscription…",
    toastRegistered: "{name} a rejoint le vivier !",
    toastRegisterError: "L'inscription a échoué. Réessayez.",
    formError: "Remplissez tous les champs (stats de 1 à 99).",
    scoutingDesk: "Bureau de Recrutement",
    clearFilters: "Effacer les filtres",
    searchLabel: "Demandez au Chef Recruteur",
    searchPlaceholder: "ex : Je cherche un défenseur rapide...",
    allPositions: "Tous les Postes",
    allStyles: "Tous les Styles",
    allCommitments: "Tous les Engagements",
    position: "Poste",
    style: "Style",
    commitment: "Engagement",
    breakingAvailable: "Alerte — Disponibles Maintenant",
    freeAgents: "Agents Libres",
    dealsDone: "Transferts Bouclés",
    signedOffMarket: "Transferts Finalisés",
    transferComplete: "TRANSFERT CONCLU",
    freeAgentTag: "Agent Libre",
    signedBadge: "SIGNÉ",
    signFullSeason: "Signer Saison Complète",
    finalizingDeal: "Finalisation du transfert…",
    pace: "Vitesse",
    defense: "Défense",
    passing: "Passe",
    hereWeGo: "Here We Go!",
    officialConfirmed: "Officiel et Confirmé",
    exclusiveText:
      "🚨 HERE WE GO ! EXCLUSIF : {name} signe pour toute la saison à {city} ! Le {style} {position} n'est plus sur le marché. ✍️🤝",
    close: "Fermer",
    copyToChat: "Copier dans le Presse-papiers",
    copied: "Copié !",
    marketSwept: "Marché vidé",
    noMatch: "Aucun agent libre ne correspond à vos critères.",
    allSigned: "Tous les joueurs ont signé. Réinitialisez le marché pour rouvrir le mercato.",
    resetFiltersBtn: "Réinitialiser les filtres",
    signalLost: "Signal perdu",
    connectionError: "Impossible de joindre le bureau des transferts. Vérifiez votre connexion et réessayez.",
    retry: "Réessayer",
    toastReset: "Marché réinitialisé — tous les joueurs sont à nouveau libres.",
    toastResetError: "Impossible de réinitialiser le marché. Réessayez.",
    toastSignError: "Le transfert a capoté à la dernière minute. Réessayez.",
    toastCopied: "Info copiée — collez-la dans le chat d'équipe !",
    footer: "Radar Ligue Amateur — La confiance des capitaines. Zéro faux ITK.",
  },
  ar: {
    title: "رادار دوري الهواة",
    subtitle: "الوجهة الأولى لانتقالات الهواة",
    liveMarket: "السوق مباشر",
    breaking: "عاجل",
    ticker: [
      "سوق الانتقالات مفتوح",
      "عقود الموسم الكامل متاحة",
      "الفحوصات الطبية تُحجز يومياً",
      "القادة في حالة تأهب قصوى",
      "حصري: أفضل المواهب ما زالت بلا توقيع",
    ],
    totalFreeAgents: "إجمالي اللاعبين الأحرار",
    resetMarket: "إعادة تعيين السوق",
    selectMarket: "اختر السوق",
    allCities: "كل المدن",
    registerFreeAgent: "سجّل كلاعب حر",
    transferMarket: "سوق الانتقالات",
    clubhouse: "النادي الاجتماعي",
    clubhouseDesc: "بطولات وفعاليات اجتماعية ومباريات ودية في سوقك.",
    communityBoard: "لوحة إعلانات المجتمع",
    postEvent: "انشر فعالية",
    postEventTitle: "انشر في النادي الاجتماعي",
    postEventDesc: "شارك بطولة أو فعالية اجتماعية أو مباراة ودية مع مدينتك.",
    eventTextLabel: "تفاصيل الفعالية",
    eventPlaceholder: "مثال: ⚽ مباراة ودية في بن بارك الساعة 6 مساءً",
    submitPost: "نشر",
    posting: "جارٍ النشر…",
    toastPosted: "تم نشر الفعالية في النادي الاجتماعي!",
    toastPostError: "تعذر نشر الفعالية. حاول مجدداً.",
    postFormError: "يرجى إدخال تفاصيل الفعالية.",
    noPosts: "لا توجد فعاليات في هذا السوق بعد. كن أول من ينشر!",
    watchTape: "شاهد الفيديو",
    uploadVideo: "رفع من الاستوديو / الجهاز",
    uploading: "جارٍ الرفع…",
    removeFile: "إزالة",
    whatsHappening: "ماذا يحدث في الملعب؟",
    attachMedia: "إرفاق صورة/فيديو",
    mediaAttached: "تم إرفاق وسائط",
    writeComment: "اكتب تعليقاً…",
    send: "إرسال",
    you: "أنت",
    roleCaptain: "كابتن",
    rolePlayer: "لاعب",
    roleAdmin: "إدارة الدوري",
    highlightClip: "مقطع مميز",
    leagueType: "تفضيل الدوري",
    allLeagueTypes: "كل تفضيلات الدوري",
    selectLeague: "اختر نوع الدوري",
    scoutingOrigin: "مصدر الاستكشاف",
    originNone: "لا يوجد بعد",
    goodRecBadge: "🔥 لاعب منتظم في GoodRec",
    casaBadge: "🏆 محترف دوري CASA",
    videoLabel: "رابط فيديو المهارات",
    videoPlaceholder: "مثال: https://youtube.com/watch?v=...",
    optionalTag: "(اختياري)",
    registerTitle: "انضم إلى قاعدة المواهب",
    registerDesc: "اجعل القادة في جميع أنحاء البلاد يكتشفونك.",
    nameLabel: "الاسم",
    cityLabel: "المدينة",
    namePlaceholder: "مثال: أسطورة دوري الأحد",
    stylePlaceholder: "مثال: لاعب وسط تيكي-تاكا",
    commitmentPlaceholder: "مثال: 100% نهاية الأسبوع",
    selectCity: "اختر مدينة",
    selectPosition: "اختر مركزاً",
    submitRegister: "تسجيل",
    cancel: "إلغاء",
    registering: "جارٍ التسجيل…",
    toastRegistered: "انضم {name} إلى قاعدة المواهب!",
    toastRegisterError: "فشل التسجيل. حاول مجدداً.",
    formError: "يرجى ملء جميع الحقول (الإحصائيات من 1 إلى 99).",
    scoutingDesk: "مكتب الكشافة",
    clearFilters: "مسح الفلاتر",
    searchLabel: "اسأل كبير الكشافين",
    searchPlaceholder: "مثال: أحتاج مدافعاً سريعاً...",
    allPositions: "كل المراكز",
    allStyles: "كل الأساليب",
    allCommitments: "كل مستويات الالتزام",
    position: "المركز",
    style: "الأسلوب",
    commitment: "الالتزام",
    breakingAvailable: "عاجل — متاحون الآن",
    freeAgents: "اللاعبون الأحرار",
    dealsDone: "صفقات مكتملة",
    signedOffMarket: "انتقالات مكتملة",
    transferComplete: "اكتملت الصفقة",
    freeAgentTag: "لاعب حر",
    signedBadge: "موقّع",
    signFullSeason: "وقّع لموسم كامل",
    finalizingDeal: "جارٍ إتمام الصفقة…",
    pace: "السرعة",
    defense: "الدفاع",
    passing: "التمرير",
    hereWeGo: "Here We Go!",
    officialConfirmed: "رسمي ومؤكد",
    exclusiveText:
      "🚨 !HERE WE GO حصري: {name} يوقّع عقداً لموسم كامل في {city}! {style} {position} أصبح خارج السوق. ✍️🤝",
    close: "إغلاق",
    copyToChat: "نسخ إلى الحافظة",
    copied: "تم النسخ!",
    marketSwept: "السوق فارغ تماماً",
    noMatch: "لا يوجد لاعبون أحرار يطابقون معايير البحث.",
    allSigned: "تم توقيع جميع اللاعبين. أعد تعيين السوق لفتح النافذة من جديد.",
    resetFiltersBtn: "إعادة تعيين الفلاتر",
    signalLost: "انقطعت الإشارة",
    connectionError: "تعذر الوصول إلى مكتب الانتقالات. تحقق من الاتصال وحاول مجدداً.",
    retry: "إعادة المحاولة",
    toastReset: "تمت إعادة تعيين السوق — جميع اللاعبين أحرار من جديد.",
    toastResetError: "تعذر إعادة تعيين السوق. حاول مجدداً.",
    toastSignError: "انهارت الصفقة في اللحظة الأخيرة. حاول مجدداً.",
    toastCopied: "تم نسخ الخبر — الصقه في محادثة الفريق!",
    footer: "رادار دوري الهواة — موثوق من القادة.",
  },
  tr: {
    title: "Amatör Lig Radarı",
    subtitle: "Amatör Transferlerin Merkezi",
    liveMarket: "Canlı Piyasa",
    breaking: "Son Dakika",
    ticker: [
      "TRANSFER PENCERESİ AÇIK",
      "TAM SEZONLUK SÖZLEŞMELER MEVCUT",
      "SAĞLIK KONTROLLERİ HER GÜN",
      "KAPTANLAR KIRMIZI ALARMDA",
      "ÖZEL: EN İYİ YETENEKLER HALA İMZASIZ",
    ],
    totalFreeAgents: "Toplam Serbest Oyuncu",
    resetMarket: "Piyasayı Sıfırla",
    selectMarket: "Pazar Seç",
    allCities: "Tüm Şehirler",
    registerFreeAgent: "Serbest Oyuncu Olarak Kaydol",
    transferMarket: "Transfer Piyasası",
    clubhouse: "Kulüp Evi",
    clubhouseDesc: "Pazarınızdaki turnuvalar, sosyal etkinlikler ve halı saha maçları.",
    communityBoard: "Topluluk Panosu",
    postEvent: "Etkinlik Paylaş",
    postEventTitle: "Kulüp Evi'nde Paylaş",
    postEventDesc: "Şehrinle bir turnuva, sosyal etkinlik veya maç paylaş.",
    eventTextLabel: "Etkinlik detayları",
    eventPlaceholder: "örn: ⚽ Penn Park'ta maç, 18:00",
    submitPost: "Paylaş",
    posting: "Paylaşılıyor…",
    toastPosted: "Etkinlik Kulüp Evi'nde paylaşıldı!",
    toastPostError: "Etkinlik paylaşılamadı. Tekrar deneyin.",
    postFormError: "Lütfen etkinlik detaylarını girin.",
    noPosts: "Bu pazarda henüz etkinlik yok. İlk paylaşan sen ol!",
    watchTape: "Videoyu İzle",
    uploadVideo: "Galeriden / Cihazdan Yükle",
    uploading: "Yükleniyor…",
    removeFile: "Kaldır",
    whatsHappening: "Sahada neler oluyor?",
    attachMedia: "Görsel/Video Ekle",
    mediaAttached: "Medya eklendi",
    writeComment: "Bir yorum yaz…",
    send: "Gönder",
    you: "Sen",
    roleCaptain: "Kaptan",
    rolePlayer: "Oyuncu",
    roleAdmin: "Lig Yöneticisi",
    highlightClip: "Öne çıkan klip",
    leagueType: "Lig Tercihi",
    allLeagueTypes: "Tüm Lig Tercihleri",
    selectLeague: "Lig türü seçin",
    scoutingOrigin: "Gözlem Kaynağı",
    originNone: "Henüz yok",
    goodRecBadge: "🔥 GoodRec Pickup Müdavimi",
    casaBadge: "🏆 CASA Ligi Emektarı",
    videoLabel: "Öne Çıkanlar Video Bağlantısı",
    videoPlaceholder: "örn: https://youtube.com/watch?v=...",
    optionalTag: "(isteğe bağlı)",
    registerTitle: "Yetenek Havuzuna Katıl",
    registerDesc: "Ülke genelindeki kaptanlar seni keşfetsin.",
    nameLabel: "İsim",
    cityLabel: "Şehir",
    namePlaceholder: "örn: Pazar Ligi Efsanesi",
    stylePlaceholder: "örn: Tiki-Taka Orta Saha",
    commitmentPlaceholder: "örn: %100 Hafta Sonu",
    selectCity: "Bir şehir seçin",
    selectPosition: "Bir mevki seçin",
    submitRegister: "Kaydol",
    cancel: "İptal",
    registering: "Kaydediliyor…",
    toastRegistered: "{name} yetenek havuzuna katıldı!",
    toastRegisterError: "Kayıt başarısız. Tekrar deneyin.",
    formError: "Lütfen tüm alanları doldurun (istatistikler 1-99).",
    scoutingDesk: "Gözlemci Masası",
    clearFilters: "Filtreleri temizle",
    searchLabel: "Baş Gözlemciye Sor",
    searchPlaceholder: "örn: Hızlı bir stoper lazım...",
    allPositions: "Tüm Mevkiler",
    allStyles: "Tüm Stiller",
    allCommitments: "Tüm Katılım Düzeyleri",
    position: "Mevki",
    style: "Stil",
    commitment: "Katılım",
    breakingAvailable: "Son Dakika — Şimdi Müsait",
    freeAgents: "Serbest Oyuncular",
    dealsDone: "Biten Transferler",
    signedOffMarket: "Tamamlanan Transferler",
    transferComplete: "TRANSFER TAMAM",
    freeAgentTag: "Serbest Oyuncu",
    signedBadge: "İMZALANDI",
    signFullSeason: "Tüm Sezon İmzala",
    finalizingDeal: "Anlaşma tamamlanıyor…",
    pace: "Hız",
    defense: "Defans",
    passing: "Pas",
    hereWeGo: "Here We Go!",
    officialConfirmed: "Resmi ve Onaylı",
    exclusiveText:
      "🚨 HERE WE GO! ÖZEL: {name} {city} şehrinde tam sezonluk sözleşme imzaladı! {style} {position} artık piyasada değil. ✍️🤝",
    close: "Kapat",
    copyToChat: "Panoya Kopyala",
    copied: "Kopyalandı!",
    marketSwept: "Piyasa tamamen boş",
    noMatch: "Arama kriterlerinize uyan serbest oyuncu yok.",
    allSigned: "Tüm oyuncular imzalandı. Pencereyi yeniden açmak için piyasayı sıfırlayın.",
    resetFiltersBtn: "Filtreleri sıfırla",
    signalLost: "Sinyal kayboldu",
    connectionError: "Transfer masasına ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.",
    retry: "Tekrar dene",
    toastReset: "Piyasa sıfırlandı — tüm oyuncular yeniden serbest.",
    toastResetError: "Piyasa sıfırlanamadı. Tekrar deneyin.",
    toastSignError: "Anlaşma son anda çöktü. Tekrar deneyin.",
    toastCopied: "Haber kopyalandı — takım sohbetine yapıştır!",
    footer: "Amatör Lig Radarı — Kaptanların güvendiği kaynak.",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem("rlr-lang");
      return translations[saved] ? saved : "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("rlr-lang", lang);
    } catch {
      // ignore storage errors
    }
    const isRtl = lang === "ar";
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let value = translations[lang]?.[key] ?? translations.en[key] ?? key;
      if (Array.isArray(value)) return value;
      if (vars && typeof value === "string") {
        Object.entries(vars).forEach(([k, v]) => {
          value = value.split(`{${k}}`).join(v);
        });
      }
      return value;
    },
    [lang]
  );

  const value = useMemo(
    () => ({ lang, setLang, t, isRtl: lang === "ar" }),
    [lang, t]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
